import * as React from 'react';

import { createIcon } from '../Icon';
export const SidebarIcon = createIcon(
  <React.Fragment>
    <rect height={18} rx={2} ry={2} width={18} x={3} y={3} />
    <line x1={9} x2={9} y1={3} y2={21} />
  </React.Fragment>,
  'SidebarIcon'
);
